const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t-2 border-milo-beige-dark mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-serif text-milo-black mb-4">MILO Pastelería</h3>
            <p className="text-milo-gray text-sm">
              Productos artesanales hechos con dedicación y los mejores ingredientes.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-serif text-milo-black mb-4">Enlaces</h4>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-milo-gray hover:text-milo-gold transition-colors text-sm">
                  Inicio
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-serif text-milo-black mb-4">Contacto</h4>
            <p className="text-milo-gray text-sm">
              WhatsApp: +54 9 223 518-4474
            </p>
          </div>
        </div>

        <div className="border-t border-milo-beige-dark mt-8 pt-8 text-center">
          <p className="text-milo-gray text-sm">
            © {currentYear} MILO Pastelería. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
